import { render } from "./CountryWithPhone.vue?vue&type=template&id=2ae02bb0&scoped=true"
import script from "./CountryWithPhone.vue?vue&type=script&lang=js"
export * from "./CountryWithPhone.vue?vue&type=script&lang=js"

import "./CountryWithPhone.vue?vue&type=style&index=0&id=2ae02bb0&scoped=true&lang=css"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae02bb0"]])

export default __exports__